module.exports = __webpack_public_path__ + "resources/img/img_criminal_ip_for_asm2_m.0a3627d3a6a0ca0cac9ef627657c98a4.png";